import { ColDef, ColGroupDef } from 'ag-grid-community';
import { Arrays } from './arrays';
import { Colors } from './colors';
import { Dates } from './dates';
import { Files } from './files';
import { Numbers } from './numbers';
import { Objects } from './objects';
import { Times } from './times.util';
import { Values } from './values';
/**
 * ag-Grid 용 컬럼 생성 유틸리티
 */
export class Columns {

  private columns: any[] = [];

  constructor() {
  }

  public static builder(): Columns {
    return new Columns();
  }

  public addCol(col: ColDef): Columns {
    this.columns.push(col);
    return this;
  }

  public addGroupCol(colGroup: ColGroupDef): Columns {
    this.columns.push(colGroup);
    return this;
  }

  public addGroup(groupId: string, headerName: string, children?: (ColDef | ColGroupDef)[], headerGroupComponentFramework?: any, headerGroupComponentParams?: any): Columns {
    return this.addGroupCol({
      groupId: groupId,
      headerName: headerName,
      headerTooltip: headerName,
      children: children,
      headerGroupComponentFramework: headerGroupComponentFramework,
      headerGroupComponentParams: headerGroupComponentParams,
      marryChildren: true
    });
  }

  public addChildenCol(groupId: string, col: (ColDef | ColGroupDef)): Columns {

    let findGroup: ColGroupDef = this.columns.find(c => c.groupId == groupId);

    if (!findGroup) {
      console.log("can not find ColGroup: ", groupId);
      return this;
    }

    if (findGroup.children)
      findGroup.children.push(col);
    else
      findGroup.children = [col];

    return this;
  }

  public addChilden(groupId: string, columnField: string, headerName: string, visible: boolean = true, valueGetter: any = null,
    width: number = 80, minWidth: number = null, maxWidth: number = null, cellRendererFramework: any = null,
    cellStyle: any = null, cellClass: any = null, cellClassRules: any = null, comparator: any = null, tooltipValueGetter: any = null): Columns {

    let findGroup: ColGroupDef = this.columns.find(c => c.groupId == groupId);

    if (!findGroup) {
      console.log("can not find ColGroup: ", groupId);
      return this;
    }

    let col = {
      field: columnField,
      tooltipField: valueGetter ? null : columnField,
      headerName: headerName,
      headerTooltip: headerName,
      hide: !visible,
      floatingFilter: false,
      valueGetter: valueGetter,
      tooltipValueGetter: tooltipValueGetter ? tooltipValueGetter : valueGetter,
      cellRendererFramework: cellRendererFramework,
      cellStyle: cellStyle,
      cellClass: cellClass,
      cellClassRules: cellClassRules,
      width: width,
      minWidth: minWidth ? minWidth : width,
      maxWidth: maxWidth,
      comparator: comparator
    };

    if (findGroup.children)
      findGroup.children.push(col);
    else
      findGroup.children = [col];

    return this;
  }

  public setGroup(groupId: string, headerName: string, children: (ColDef | ColGroupDef)[], headerGroupComponentFramework?: any, headerGroupComponentParams?: any): Columns {
    let findGroup: ColGroupDef = this.columns.find(c => c.groupId == groupId);

    if (!findGroup)
      return this.addGroup(groupId, headerName, children, headerGroupComponentFramework, headerGroupComponentParams);

    findGroup.children = children;
    findGroup.headerName = headerName;
    findGroup.headerTooltip = headerName;
    findGroup.headerGroupComponentFramework = headerGroupComponentFramework;
    findGroup.headerGroupComponentParams = headerGroupComponentParams;

    return this;
  }

  public add(columnField: string, headerName: string, visible: boolean = true, valueGetter: any = null,
    width: number = 80, minWidth: number = null, maxWidth: number = null, cellRendererFramework: any = null,
    cellStyle: any = null, cellClass: any = null, cellClassRules: any = null, comparator: any = null, tooltipValueGetter: any = null): Columns {

    return this.addCol({
      field: columnField,
      tooltipField: valueGetter ? null : columnField,
      headerName: headerName,
      headerTooltip: headerName,
      hide: !visible,
      floatingFilter: false,
      valueGetter: valueGetter,
      tooltipValueGetter: tooltipValueGetter ? tooltipValueGetter : valueGetter,
      cellRendererFramework: cellRendererFramework,
      cellStyle: cellStyle,
      cellClass: cellClass,
      cellClassRules: cellClassRules,
      width: width,
      minWidth: minWidth ? minWidth : width,
      maxWidth: maxWidth,
      comparator: comparator
    });
  }

  /**
   * 선택한 체크박스 컬럼 추가
   * @param columnField
   * @param headerName 
   * @param visible 
   * @param headerCheckboxSelection 
   */
  public addCheckBox(colId: string, headerName: string, visible: boolean = true, headerCheckboxSelection: boolean = true, groupId?: string): Columns {

    let col: ColDef = {
      colId: colId,
      headerName: headerName,
      hide: !visible,
      checkboxSelection: true,
      headerCheckboxSelection: headerCheckboxSelection,
      headerCheckboxSelectionFilteredOnly: true,
      sortable: false, // TODO Sort기능 구현필요
      filter: false, // TODO Filter기능 구현필요
      width: 35,
      minWidth: 35,
      maxWidth: 40,
      floatingFilter: false,
      cellStyle: { 'display': 'flex', 'align-items': 'center' }
    };

    if (groupId)
      return this.addChildenCol(groupId, col);
    else
      return this.addCol(col);
  }

  public addNumeric(columnField: string, headerName: string, visible: boolean = true, groupId?: string): Columns {
    let valueGetter: Function = (param) =>  Number(param.data[columnField]);
    let valueFormatter: Function = (param) => new Intl.NumberFormat().format(param.value);
    let comparator: Function = (o1, o2) => o1 - o2;

    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 80, null, null, null, null, valueFormatter, comparator, null);
    else
      return this.add(columnField, headerName, visible, valueGetter, 80, null, null, null, null, valueFormatter, comparator, null);
  }
  
  public addNumericUnit(columnField: string, headerName: string, visible: boolean = true, groupId?: string): Columns {
    let valueGetter: Function = (param) => { return Numbers.conversionUnit(param.data[columnField], 1); };
    let tooltipGetter: Function = (param) => { return new Intl.NumberFormat().format(param.data[columnField]); };
    let comparator: Function = (o1, o2) => { return o1 - o2; };

    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator, tooltipGetter);
    else
      return this.add(columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator, tooltipGetter);
  }

  /**
   * 날짜형(yyyy-MM-dd) 컬럼추가 
   * @param columnField 
   * @param headerName 
   * @param visible 
   * @param groupId 컬럼그룹내 등록 
   */
  public addDate(columnField: string, headerName: string, visible: boolean = true, groupId?: string): Columns {
    let valueGetter: Function = (param) => { return Dates.toDateString(Objects.safeGetValue(param.data, columnField)); };
    let comparator: Function = (o1, o2, n1, n2) => { return Dates.compareDate(Objects.safeGetValue(n1.data, columnField), Objects.safeGetValue(n2.data, columnField), false); };

    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 180, null, null, null, null, null, null, comparator);
    else
      return this.add(columnField, headerName, visible, valueGetter, 180, null, null, null, null, null, null, comparator);
  }

  /**
   * 배열에 담긴 값을 Idx로 반환
   * @param columnField 
   * @param headerName 
   * @param visible 
   * @param groupId 컬럼그룹내 등록 
   */
  public addArray(columnField: string, headerName: string, visible: boolean = true, valueIndex: number = 0, groupId?: string, comparator?: Function): Columns {
    let valueGetter: Function = (param) => { 
      const value = Objects.safeGetValue(param.data, columnField); 

      if (Arrays.isNotEmpty(value))
        return Arrays.safeGetValue(value, valueIndex);
      else
        return null;
    };

    if (groupId)
      return this.addChilden(groupId, columnField + String(valueIndex), headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator);
    else
      return this.add(columnField + String(valueIndex), headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator);
  }

  /**
   * 시/분을 추가한 날짜형(yyyy-MM-dd HH:mm:ss) 컬럼추가
   * @param columnField 
   * @param headerName 
   * @param visible 
   * @param groupId 컬럼그룹내 등록 
   */
  public addDateTime(columnField: string, headerName: string, visible: boolean = true, groupId?: string): Columns {
    let valueGetter: Function = (param) => { return Dates.toDateTimeString(Objects.safeGetValue(param.data, columnField)); };
    let comparator: Function = (o1, o2, n1, n2) => { return Dates.compareDate(Objects.safeGetValue(n1.data, columnField), Objects.safeGetValue(n2.data, columnField), true); };

    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator);
    else
      return this.add(columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator);
  }

  /**
   * FromNow 컬럼추가
   * @param columnField 
   * @param headerName 
   * @param visible 
   * @param groupId 컬럼그룹내 등록 
   */
  public addFromNow(columnField: string, headerName: string, visible: boolean = true, groupId?: string): Columns {
    let valueGetter: Function = (param) => { return Dates.fromNow(Objects.safeGetValue(param.data, columnField), " 전"); };
    let comparator: Function = (o1, o2, n1, n2) => { return Dates.compareDate(Objects.safeGetValue(n1.data, columnField), Objects.safeGetValue(n2.data, columnField), true); };
    let tooltipValueGetter: Function = (param) => { return Dates.toDateTimeString(Objects.safeGetValue(param.data, columnField)); };
    
    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator, tooltipValueGetter);
    else
      return this.add(columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator, tooltipValueGetter);
  }

  /**
   * Object 컬럼 추가 (Json으로 표시)
   * @param columnField 
   * @param headerName 
   * @param visible 
   * @param groupId 컬럼그룹내 등록 
   */
    public addObject(columnField: string, headerName: string, visible: boolean = true, groupId?: string): Columns {
    let valueGetter: Function = (param) => { return JSON.stringify(Objects.safeGetValue(param.data, columnField)); };

    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 180, null, null, null, null, null, null, null);
    else
      return this.add(columnField, headerName, visible, valueGetter, 180, null, null, null, null, null, null, null);
  }
  

  /**
   * 파일사이즈 컬럼추가
   * @param columnField 
   * @param headerName 
   * @param visible 
   * @param groupId 컬럼그룹내 등록 
   */
  public addFileSize(columnField: string, headerName: string, visible: boolean = true, groupId?: string): Columns {
    let valueGetter: Function = (param) => { return Files.formatBytes(Objects.safeGetValue(param.data, columnField, 0), 2, 'N/A'); };
    let tooltipValueGetter: Function = (param) => { return Files.formatBytes(Objects.safeGetValue(param.data, columnField, 0), 2, 'N/A'); };
    let comparator: Function = (o1, o2, n1, n2) => { return (n1.data[columnField] || 0) - (n2.data[columnField] || 0); };
    
    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator, tooltipValueGetter);
    else
      return this.add(columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator, tooltipValueGetter);
  }
  
  /**
   * 시/분 만 표시하며 툴팁으로 전체 일시를 표시하는 컬럼추가
   * column: HH:mm
   * tooltip: yyyy-MM-dd HH:mm:ss
   * @param columnField 
   * @param headerName 
   * @param visible 
   * @param groupId 컬럼그룹내 등록 
   */
  public addTime(columnField: string, headerName: string, visible: boolean = true, groupId?: string): Columns {
    let valueGetter: Function = (param) => { return Dates.toString(Objects.safeGetValue(param.data, columnField), 'HH:mm'); };
    let comparator: Function = (o1, o2, n1, n2) => { return Dates.compareDate(Objects.safeGetValue(n1.data, columnField), Objects.safeGetValue(n2.data, columnField), true); };
    let tooltipValueGetter: Function = (param) => { return Dates.toDateTimeString(Objects.safeGetValue(param.data, columnField)); };

    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator, tooltipValueGetter);
    else
      return this.add(columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator, tooltipValueGetter);
  }

  public addFromTime(columnField: string, headerName: string, visible: boolean = true, groupId?: string): Columns {
    let valueGetter: Function = (param) => { return Times.toString(Objects.safeGetValue(param.data, columnField)); };
    let comparator: Function = (o1, o2, n1, n2) => { return Dates.compareDate(Objects.safeGetValue(n1.data, columnField), Objects.safeGetValue(n2.data, columnField), true); };

    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator);
    else
      return this.add(columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator);
  }

  /**
   * 퍼센트 표시 컬럼
   * @param columnField 
   * @param headerName 
   * @param visible 
   * @param groupId 컬럼그룹내 등록 
   */
  public addPercent(columnField: string, headerName: string, visible: boolean = true, groupId?: string): Columns {
    let valueGetter: Function = (param) => { return Objects.safeGetValue(param.data, columnField, '0') + '%'; };
    let comparator: Function = (o1, o2, n1, n2) => { return Objects.safeGetValue(n1.data, columnField) - Objects.safeGetValue(n2.data, columnField); };
    let tooltipValueGetter: Function = (param) => { return Objects.safeGetValue(param.data, columnField, '0') + '%'; };

    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator, tooltipValueGetter);
    else
      return this.add(columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator, tooltipValueGetter);
  }

  /**
   * Boolean 형 컬럼 추가
   * @param columnField 
   * @param headerName 
   * @param visible 
   * @param trueString 
   * @param falseString 
   * @param groupId 컬럼그룹내 등록 
   */
  public addBoolean(columnField: string, headerName: string, visible: boolean = true, trueString: string = 'Y', falseString: string = 'N', groupId?: string): Columns {
    let valueGetter: Function = (param) => { return param.data[columnField] ? trueString : falseString };
    let comparator: Function = (o1, o2, n1, n2) => {
      let o1value: boolean = n1.data[columnField];
      let o2value: boolean = n2.data[columnField];

      return o1value === o2value ? 0 : (o1value ? 1 : -1);
    }
    let cellStyle: Function = (param) => {
      if (param.data[param.colDef.field]) {
        return { color: Colors.SEA_GREEN };
      }
      return { color: Colors.INDIAN_RED };
    };

    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 80, null, null, null, cellStyle, null, null, comparator);
    else
      return this.add(columnField, headerName, visible, valueGetter, 80, null, null, null, cellStyle, null, null, comparator);
  }

  /**
   * 열거형 컬럼추가
   * @param columnField 
   * @param headerName 
   * @param visible 
   * @param source 
   * @param groupId 컬럼그룹내 등록 
   */
  public addType(columnField: string, headerName: string, visible: boolean = true, source: any[], comparator?: any, groupId?: string): Columns {
    let valueGetter: Function = (param) => { return Values.getLabel(param.data[columnField], source) };

    if (groupId)
      return this.addChilden(groupId, columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator);
    else
      return this.add(columnField, headerName, visible, valueGetter, 80, null, null, null, null, null, null, comparator);
  }

  /**
   * 
   * @param columnField 
   * @param key 
   * @param value 
   */
  public set(columnField: string, key: keyof ColDef, value: any) {
    let find = this.findCol(columnField, this.columns);

    if (!find) {
      console.log('can not find column', columnField, key, value);
      return this;
    }

    find[key.toString()] = value;
    return this;
  }

  public setToolTip(columnField: string, tooltipField: string, valueGetter?: any) {
    let find = this.findCol(columnField, this.columns);

    if (!find) {
      console.log('can not find column', columnField);
      return this;
    }

    find['tooltipField'] = tooltipField;

    if (valueGetter)
      find['tooltipValueGetter'] = valueGetter;
      
    return this;
  }

  public findCol(columnField: string, columns: any[]): any {

    if (!columns) return null;

    let findCol: any = null;

    for (let i = 0; i < columns.length; i++) {
      let column: any = columns[i];

      if (column.hasOwnProperty('field') && column.field == columnField)
        findCol = column;

      if (!findCol && column.hasOwnProperty('children') && column.children)
        findCol = this.findCol(columnField, column.children);

      if (findCol)
        break;
    }

    return findCol;
  }

  public setWidth(columnField: string, width: string) {
    let col = this.columns.find(r => r.field == columnField);
    col['width'] = Number(width);
    return this;
  }

  /**
   * 컬럼 제거용 (headerName 목록으로 컬럼제거)
   * @param headerNames 
   */
  public removes(headerNames: string[]): Columns {
    if (Arrays.isEmpty(headerNames))
      return this;

    headerNames.forEach((headerName: string) => {
      let column = this.columns.find((column) => column.headerName == headerName);

      if (column)
        this.columns = Arrays.removeItem(this.columns, column);
    });

    return this;
  }

  public removeHeaderGroups(headers: any): Columns {
    if (Arrays.isEmpty(headers))
      return this;

    headers.forEach((header: any) => {
      let column = this.columns.find((column) => column.groupId == header.key);


      if (column)
        this.columns = Arrays.removeItem(this.columns, column);
    });

    return this;
  }

  public build(): any {
    return this.columns;
  }

  public buildMaker(columns: any) {
    let printStr: string = "new Columns()";
    Object.keys(columns).forEach(key => {

      let print: any = {
        columnField: "",
        code: "",
        type: "custom",
        visible: false,
        renderComponent: null,
        onComponentInitFunction: null,
        valuePrepareFunction: null
      };

      printStr += `.append("${key}", `;

      let values: any = columns[key];

      console.log(key);

      Object.keys(values).forEach(key2 => {
        if (print.hasOwnProperty(key2))
          print[key2] = values[key2];
      });

      printStr += `"${print["code"]}", "${print['type']}", ${print['visible']}`;

      if (print["renderComponent"] != null)
        printStr += `, ${print['renderComponent'].name}`;

      if (print["onComponentInitFunction"] != null)
        printStr += `, ${print['onComponentInitFunction'].toString()}`;

      if (print["valuePrepareFunction"] != null)
        printStr += `, ${print['valuePrepareFunction'].toString()}`;

      printStr += ")";
    });

    console.log(printStr + ".build();");
  }
}

export declare type ColumnType = 'text' | 'html' | 'custom';
